export var VERSION = '1.14.1';
//# sourceMappingURL=version.js.map